
import { defineComponent, reactive, ref, watch } from "vue";
import {
  AdminTableLayout,
  DatePicker,
  FaceSheetReomteSelect,
  DefaultOptionSelect,
  ReportTable,
  OrderTravel,
  ExportButton,
} from "@/components/Common";

import { zcatPoint, fmtExtractWaybillCode } from "@/utils/utilFuns";
import moment from "dayjs";

import { useRoute } from "vue-router";
import {
  useDynamicDialog,
  usePagination,
  useReportTableShowColumn,
} from "@/hooks";

import { tableColumn } from "./logisticsSearchColum";

import {
  CheckMerchantBillCodeWithBillInfo,
  GetTractRecord,
  QueryBillDetailInfos,
} from "@/api-server/modules/defaultServer";
import { formatThisMonth } from "@/utils/formatter";
import { RootState } from "@/@types/store";
import { useStore } from "vuex";

export default defineComponent({
  name: "LogisticsSearch",
  components: {
    AdminTableLayout,
    DatePicker,
    FaceSheetReomteSelect,
    DefaultOptionSelect,
    ReportTable,
    OrderTravel,
    ExportButton,
  },

  setup() {
    const route = useRoute();
    const store = useStore<RootState>();
    const { getModelUUID, openModel } = useDynamicDialog();
    const formData = reactive({
      partnerIds: "",
      siteCode: "",
      time: [moment(), moment()],
      billStatus: "",
      receiveMobile: "",
      receiveName: "",
      sendName: "",
      billCodes: (route.query.orderNos as string) || "",
    });
    const dialog = reactive<{
      visible: boolean;
      loading: boolean;
      orderInfo: BUSINESS_SERVE_PLATFORM_PC.GetTractRecordResponseDataItem;
    }>({
      visible: false,
      loading: false,
      orderInfo: {},
    });

    const calendarTime = ref<Date[]>([]);

    const { showTableColumn } = useReportTableShowColumn(tableColumn);

    watch(() => route.query, (query: any) => {
      formData.partnerIds = query.partnerId || ''
      formData.billStatus = query.status || ''
      route.query.st&&route.query.et&&(formData.time = [query.st, query.et])
    })

    const {
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      tableData,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
      errorCode,
    } = usePagination(
      QueryBillDetailInfos.fetch,
      formData,
      (editFormData) => {
        zcatPoint(["运单管理", "查询按钮", "运单列表"]);
        if (editFormData.receiveMobile) {
          zcatPoint(["运单管理", "查询按钮", "收件人手机号"]);
        }
        return postData(editFormData)
      },
      { noPageCount: true }
    );

    const postData = (data = formData) => {
        if (data.billCodes) {
          return {
            billCodes: fmtExtractWaybillCode(data.billCodes),
          };
        }
        return {
          partnerIds: data.partnerIds,
          siteCode: data.siteCode,
          billStatus: data.billStatus,
          receiveMobile: data.receiveMobile,
          receiveName: data.receiveName,
          sendName: data.sendName,
          startTime:
            data.time.length > 0
              ? moment(data.time[0]).format("YYYYMMDD")
              : undefined,
          endTime:
            data.time.length > 0
              ? moment(data.time[1]).format("YYYYMMDD")
              : undefined,
        };
    }

    const handleClick = async (billCodes: string) => {
      dialog.visible = true;
      dialog.loading = true;
      const {
        data: { data: billDataList },
      } = await GetTractRecord.fetch({
        billCodes: [billCodes],
      }).catch(() => {
        return {
          data: {
            data: [
              {
                billCode: billCodes,
                billDataList: [],
              },
            ],
          },
        };
      });
      dialog.loading = false;
      billDataList &&
        billDataList.length > 0 &&
        (dialog.orderInfo = billDataList[0]);
    };

    const handleCalendarChange = (dates: Date[]) => {
      calendarTime.value = dates;
    };

    async function bindBesInfo() {
      const uuid = await getModelUUID(
        "admin/base-setting/bes-manager/BesBindEditDialog"
      );
      openModel(
        uuid,
        {},
        {
          updateSuccess: requestTableData,
        }
      );
    }

    async function handleAfterSales(
      row: BUSINESS_SERVE_PLATFORM_PC.QueryBillDetailInfosResponseDataDataItem
    ) {
      const { data: { data } } = await CheckMerchantBillCodeWithBillInfo.fetch({
        billCode: row.billCode
      })
      const uuid = await getModelUUID(store.state.config.apollo.workOrderSwitch ? "admin/after-sales-new/Launch": "admin/after-sales/Launch");
      openModel(
        uuid,
        {
          formData: {
            billCode: row.billCode || "",
            newReceiverName: data?.receiveName,
            newReceiverPhone: data?.receiveMobile,
          },
        },
        {
          updateSuccess: requestTableData,
        }
      );
    }

    function deleteRepeatOrderNumber() {
      formData.billCodes = Array.from(
        new Set(formData.billCodes.split("\n"))
      ).join("\n");
    }

    watch(
      () => formData.billStatus,
      () => {
        zcatPoint(["运单管理", "物流状态", "运单列表"]);
      }
    );

    return {
      formData,
      loading,
      pageNum,
      pageSize,
      pageSizeList,
      totalNum,
      currentPageChangeHandle,
      sizeChangeHandle,
      onSearchHandle,
      requestTableData,
      showTableColumn,
      tableData,
      handleClick,
      dialog,
      formatThisMonth,
      handleCalendarChange,
      calendarTime,
      bindBesInfo,
      errorCode,
      deleteRepeatOrderNumber,
      handleAfterSales,
      postData,
    };
  },
});
